import { render, staticRenderFns } from "./Medicine.vue?vue&type=template&id=6d84ffc8"
import script from "./Medicine.vue?vue&type=script&lang=js"
export * from "./Medicine.vue?vue&type=script&lang=js"
import style0 from "./Medicine.vue?vue&type=style&index=0&id=6d84ffc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports